<div class="banner" *ngIf="pendingTasks?.length > 0" [ngClass]="{'warning-background': pendingTaskOrigin.includes('picking')}">
  <p>TAREFAS PENDENTES</p>
  <p class="description">
    Existem <span>{{pendingTasks.length}} questões </span> <span *ngIf="pendingTaskOrigin === 'picking'"> de picking</span> pendentes!
  </p>
  <button mat-button (click)="goTo()">ver todas as tarefas pendentes</button>
</div>

